import { useState } from 'react'
import '@/styles/login.css'

interface ForgotPasswordPageProps {
  onBackToLogin: () => void;
}

export function ForgotPasswordPage({ onBackToLogin }: ForgotPasswordPageProps) {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isSent, setIsSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    // ダミーの送信処理（1秒待機）
    setTimeout(() => {
      setIsSent(true)
      setIsLoading(false)
    }, 1000)
  }

  const handleBackToLogin = () => {
    setEmail('')
    setIsSent(false)
    onBackToLogin()
  }

  return (
    <div className="login-container">
      <div className="login-wrapper">
        {/* タイトル */}
        <div className="login-logo-section">
          <h1 className="login-title">
            Flowive
          </h1>
          <p className="login-subtitle">
            パスワードをお忘れの場合
          </p>
        </div>

        {/* メインカード */}
        <div className="login-card">
          {!isSent ? (
            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-form-group">
                <label htmlFor="email">
                  メールアドレス
                </label>
                <div style={{ position: 'relative' }}>
                  <div style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    zIndex: 1
                  }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M2 6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6ZM4 6L12 13L20 6H4ZM4 8V18H20V8L12 15L4 8Z" fill="#9CA3AF"/>
                    </svg>
                  </div>
                  <input
                    id="email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your-email@example.com"
                    autoComplete="email"
                    style={{ paddingLeft: '40px' }}
                  />
                </div>
                <div style={{
                  fontSize: '0.875rem',
                  color: '#6b7280',
                  marginTop: '0.5rem',
                  lineHeight: '1.4'
                }}>
                  登録されたメールアドレスにパスワードリセット用のリンクを送信します
                </div>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="login-button"
                style={{
                  backgroundColor: '#2563eb',
                  borderColor: '#2563eb'
                }}
              >
                {isLoading ? (
                  <>
                    <svg className="login-spinner" style={{ width: '20px', height: '20px' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>送信中...</span>
                  </>
                ) : (
                  'リセットリンクを送信'
                )}
              </button>
            </form>
          ) : (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
              <div style={{
                fontSize: '3rem',
                marginBottom: '1rem',
                color: '#16a34a'
              }}>
                ✓
              </div>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                marginBottom: '1rem',
                color: '#111827'
              }}>
                送信完了
              </h3>
              <p style={{
                fontSize: '0.875rem',
                color: '#6b7280',
                lineHeight: '1.5',
                marginBottom: '0'
              }}>
                <strong>{email}</strong> にパスワードリセット用のリンクを送信しました。<br />
                メールをご確認ください。
              </p>
            </div>
          )}

          <div style={{
            marginTop: '1.5rem',
            textAlign: 'center'
          }}>
            <button
              type="button"
              onClick={handleBackToLogin}
              style={{
                background: 'none',
                border: 'none',
                color: '#2563eb',
                fontSize: '0.875rem',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: '0.5rem'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#1d4ed8'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#2563eb'
              }}
            >
ログイン画面に戻る
            </button>
          </div>

          <div className="login-demo-notice">
            デモ環境 | 実際にはメールは送信されません
          </div>
        </div>

        {/* フッター */}
        <div className="login-footer">
          © 2025 Workflow Management System. All rights reserved.
        </div>
      </div>
    </div>
  )
}